
import Vue, { nextTick, ref } from "vue"
import Icon from "@/components/icon/index.vue"
import { TIcon } from "@/components/icon"
import CarouselItem from './carousItem.vue'
import { log } from 'console'
import useWheelHandler, { EWheel } from "@/hooks/useWheelHandler"
import { HomeApi } from "@/api"
import { IBannerItem } from 'home'
import { debonce } from "@/utils"

const { wheelHandler, wheelOver, onWheelDown, onWheelUp } = useWheelHandler()

const debonceWheelHandler = debonce(wheelHandler, 1)
export default Vue.extend({
	data() {
		return {
			banners: [] as IBannerItem[],
			currentIndex: null,
			dynammicRenderControl: {} as Record<number, boolean>

		}
	},
	components: {
		Icon,
		CarouselItem
	},
	created() {
		HomeApi.getBanners().then(data => {
			// console.log(data);
			if (data?.data.length) {
				this.banners = data.data
				this.dynammicRenderControl = Object.fromEntries(this.banners.map((v, i) => [i, false]))
				this.currentIndex = 0
			}
		})

		onWheelDown(() => {
			if (this.currentIndex < this.banners.length - 1) {
				this.currentIndex++
			} else {
				wheelOver()
			}
		})
		onWheelUp(() => {
			if (this.currentIndex > 0) {
				this.currentIndex--
			} else {
				wheelOver()
			}
		})
	},


	// mounted() {
	// 	const banners = this.$refs.banners as HTMLElement
	// 	if (banners) {
	// 		this.carouselHeight = banners.clientHeight
	// 		banners.style
	// 	}

	// },
	methods: {
		handleWheel(event: WheelEvent) {

			debonceWheelHandler({ event })
		},
		//一次滚动结束，可以开始新的了
		handleWheelOver(e: TransitionEvent) {
			if (e.propertyName === 'transform')
				wheelOver()

		}
	},
	computed: {
		arrowUp: () => "arrowUp",
		arrowDown: () => "arrowDown",
		bannerStyle(): string {
			return `transform:` + `translateY(-${this.currentIndex * 100}%);`
		},
		loading(): boolean {
			return !this.banners.length
		}
	},
	watch: {
		currentIndex: {
			handler(n) {
				if (n in this.dynammicRenderControl) {
					!this.dynammicRenderControl[n] && Reflect.set(this.dynammicRenderControl, n, true)
				}
			}
		}
	}
})
